//import store from "../index";

const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const CUSTOMERPROFILE_REQUEST = "CUSTOMERPROFILE_REQUEST";
const CUSTOMERPROFILE_ERROR = "CUSTOMERPROFILE_ERROR";
const CUSTOMERPROFILE_SUCCESS = "CUSTOMERPROFILE_SUCCESS";
const ALL_CUSTOMERPROFILES_REQUEST = "ALL_CUSTOMERPROFILES_REQUEST";
const ALL_CUSTOMERPROFILES_ERROR = "ALL_CUSTOMERPROFILES_ERROR";
const ALL_CUSTOMERPROFILES_SUCCESS = "ALL_CUSTOMERPROFILES_SUCCESS";
const CUSTOMER_CREATE = "CUSTOMER_CREATE";
const CUSTOMER_CREATE_SUCCESS = "CUSTOMER_CREATE_SUCCESS";
const CUSTOMER_CREATE_ERROR = "CUSTOMER_CREATE_ERROR";
const CUSTOMER_UPDATE = "CUSTOMER_UPDATE";
const CUSTOMER_LINKS_REQUEST = "CUSTOMER_LINKS_REQUEST";
const CUSTOMER_LINKS_SUCCESS = "CUSTOMER_LINKS_SUCCESS";
const CUSTOMER_LINKS_ERROR = "CUSTOMER_LINKS_ERROR";
const CUSTOMER_LINKS_CREATE = "CUSTOMER_LINKS_CREATE";
const CUSTOMER_LINKS_CREATE_SUCCESS = "CUSTOMER_LINKS_CREATE_SUCCESS";
const CUSTOMER_LINKS_CREATE_ERROR = "CUSTOMER_LINKS_CREATE_ERROR";
const CUSTOMER_LINKS_DELETE = "CUSTOMER_LINKS_DELETE";
const CUSTOMER_LINKS_DELETE_SUCCESS = "CUSTOMER_LINKS_DELETE_SUCCESS";
const CUSTOMER_LINKS_DELETE_ERROR = "CUSTOMER_LINKS_DELETE_ERROR";
const CUSTOMER_UPDATE_SUCCESS = "CUSTOMER_UPDATE_SUCCESS";
const CUSTOMER_UPDATE_ERROR = "CUSTOMER_UPDATE_ERROR";
import Vue from "vue";

const state = {status: "", customer: {}, allcustomers: [], allcustomersstatus: "", imagesLoaded: false, customerLinks: null};

const getters = {
    getMyCustomerProfile: state => state.customer,
    getActiveCustomerProfiles() {
        if(state.allcustomers === null){
            return []
        }

        return (state.allcustomers.filter(customer => {
            return customer.enabled == 1
        }))
    },
    isCustomerProfileLoaded: state => !!state.customer.customername,
    isCustomerLinksLoaded: state => !!state.customerLinks,
    isAllCustomerProfilesLoaded: state => state.allcustomers.length == 0 ? false : true,
    getAllCustomerProfiles: state => (state.allcustomers === null ? [] : state.allcustomers),
    validWriteLink: (state)=> (sourceid, targetid) => {
        if(sourceid == targetid){
            return true
        }

        if(!state.customerLinks){
            return false
        }

        let findLink = state.customerLinks.find(link => link.sourcecustomer == sourceid && link.targetcustomer == targetid && link.permission == "write")

        if(findLink){
            return true
        } else {
            return false
        }
    },
    getCustomerLinks: state => (state.customerLinks === null ? [] : state.customerLinks),
    getCustomerLinksBySource: (state)=> (customerid) => {
        if(!state.customerLinks){
            return []
        }

        return state.customerLinks.filter(customer => customer.sourcecustomer === customerid)
    },
    getCustomerLinksByTarget: (state)=> (customerid) => {
        if(!state.customerLinks){
            return []
        }

        return state.customerLinks.filter(customer => customer.targetcustomer === customerid)
    },
    getCustomerProfile: (state)=> (customerid) => {
      return state.allcustomers.find(customer => customer.customerid === customerid)
    },
    getCustomerIcon: (state)=> (customerid) => {
        if(state.allcustomers.length > 0){
            let thisCustomer = state.allcustomers.find(customer => customer.customerid === customerid)
            //return state.customer.logo64
            return thisCustomer.logo64
        } else return null
    },
    getCustomerProfileByCode: (state)=> (customerCode) => {
        return state.allcustomers.find(customer => customer.code === customerCode)
    },
    getCustomerProfileByPin: (state)=> (customerPin) => {
        return state.allcustomers.find(customer => customer.cdrpin == customerPin)
    },
    getCustomerSelectionList: (state) => { 
        //Generate list for multiselect and selection elements
        if (state.allcustomers == null) {
            return [];
        }
        let getCustomers = state.allcustomers;
        let customerIDs = [];

        for (let i = 0; i < getCustomers.length; i++) {
            let thisCustomer = {};
            thisCustomer.customerid = getCustomers[i].customerid
            thisCustomer.customername = getCustomers[i].code + " - " + getCustomers[i].customername
            thisCustomer.code = getCustomers[i].code
            customerIDs.push(thisCustomer)
        }
        return customerIDs
    }
};

const actions = {
    [CUSTOMERPROFILE_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(CUSTOMERPROFILE_REQUEST);
            commit('addLoading', {handle:'customer',name:'Load Customer Profile'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customer/me', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'customer')
                        if (resp.result === 'Success') {
                            commit(CUSTOMERPROFILE_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(CUSTOMERPROFILE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(CUSTOMERPROFILE_ERROR);
                    commit('removeLoading', 'customer')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [ALL_CUSTOMERPROFILES_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(ALL_CUSTOMERPROFILES_REQUEST);
            commit('addLoading', {handle:'allcustomers',name:'Load All Customer Profiles'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customers', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'allcustomers')
                        if (resp.result === 'Success') {
                            commit(ALL_CUSTOMERPROFILES_SUCCESS, resp)
                            state.imagesLoaded = true
                            resolve(resp)
                        } else {
                            commit(ALL_CUSTOMERPROFILES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(ALL_CUSTOMERPROFILES_ERROR);
                    commit('removeLoading', 'allcustomers')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CUSTOMER_LINKS_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(CUSTOMER_LINKS_REQUEST);
            commit('addLoading', {handle:'customerLinks',name:'Loading Customer Links'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customer/links', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'customerLinks')
                        if (resp.result === 'Success') {
                            commit(CUSTOMER_LINKS_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(ALL_CUSTOMERPROFILES_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(CUSTOMER_LINKS_ERROR);
                    commit('removeLoading', 'customerLinks')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CUSTOMER_LINKS_CREATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(CUSTOMER_LINKS_CREATE);
            commit('addLoading', {handle:'custlinkcreate',name:'Creating New Customer Link'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customer/link', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'custlinkcreate')
                        if (resp.result === 'Success') {
                            commit(CUSTOMER_LINKS_CREATE_SUCCESS)
                            dispatch(CUSTOMER_LINKS_REQUEST);
                            resolve(resp)
                        } else {
                            commit(CUSTOMER_LINKS_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(CUSTOMER_LINKS_CREATE_ERROR);
                    commit('removeLoading', 'custlinkcreate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CUSTOMER_LINKS_DELETE]: ({ commit, dispatch }, customerid) => {
        return new Promise((resolve, reject) => {
            commit(CUSTOMER_LINKS_DELETE);
            commit('addLoading', {handle:'custlinkdelete',name:'Deleting Customer Link'})


            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customer/link/' + customerid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'custlinkdelete')
                        if (resp.result === 'Success') {
                            commit(CUSTOMER_LINKS_DELETE_SUCCESS)
                            dispatch(CUSTOMER_LINKS_REQUEST);
                            resolve(resp)
                        } else {
                            commit(CUSTOMER_LINKS_DELETE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(CUSTOMER_LINKS_DELETE_ERROR);
                    commit('removeLoading', 'custlinkdelete')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CUSTOMER_CREATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(CUSTOMER_CREATE);
            commit('addLoading', {handle:'custcreate',name:'Creating New Customer'})


            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customer', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'custcreate')
                        if (resp.result === 'Success') {
                            commit(CUSTOMER_CREATE_SUCCESS, resp)
                            dispatch(ALL_CUSTOMERPROFILES_REQUEST);
                            resolve(resp)
                        } else {
                            commit(CUSTOMER_CREATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(CUSTOMER_CREATE_ERROR);
                    commit('removeLoading', 'custcreate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [CUSTOMER_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(CUSTOMER_UPDATE);
            commit('addLoading', {handle:'custupdate',name:'Update Customer'})


            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'customer/' + payload.customerid, loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'custupdate')
                        if (resp.result === 'Success') {
                            commit(CUSTOMER_UPDATE_SUCCESS, resp)
                            dispatch(ALL_CUSTOMERPROFILES_REQUEST);
                            resolve(resp)
                        } else {
                            commit(CUSTOMER_UPDATE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(CUSTOMER_UPDATE_ERROR);
                    commit('removeLoading', 'custupdate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
};

const mutations = {
    [CUSTOMERPROFILE_REQUEST]: state => {
        state.status = "loading";
    },
    [CUSTOMERPROFILE_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "customer", resp.payload);
    },
    [CUSTOMERPROFILE_ERROR]: state => {
        state.status = "error";
    },
    [ALL_CUSTOMERPROFILES_REQUEST]: state => {
        state.allcustomersstatus = "loading";
    },
    [ALL_CUSTOMERPROFILES_SUCCESS]: (state, resp) => {
        state.allcustomersstatus = "success";
        Vue.set(state, "allcustomers", resp.payload);
    },
    [ALL_CUSTOMERPROFILES_ERROR]: state => {
        state.allcustomersstatus = "error";
    },
    [CUSTOMER_LINKS_REQUEST]: state => {
        state.status = "loading";
    },
    [CUSTOMER_LINKS_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "customerLinks", resp.payload);
    },
    [CUSTOMER_LINKS_ERROR]: state => {
        state.status = "error";
    },
    [CUSTOMER_LINKS_CREATE]: state => {
        state.status = "loading";
    },
    [CUSTOMER_LINKS_CREATE_SUCCESS]: state => {
        state.status = "success";
    },
    [CUSTOMER_LINKS_CREATE_ERROR]: state => {
        state.status = "error";
    },
    [CUSTOMER_LINKS_DELETE]: state => {
        state.status = "loading";
    },
    [CUSTOMER_LINKS_DELETE_SUCCESS]: state => {
        state.status = "success";
    },
    [CUSTOMER_LINKS_DELETE_ERROR]: state => {
        state.status = "error";
    },
    [CUSTOMERPROFILE_ERROR]: state => {
        state.status = "error";
    },
    [CUSTOMER_CREATE]: state => {
        state.status = "loading";
    },
    [CUSTOMER_CREATE_SUCCESS]: state => {
        state.status = "success";
    },
    [CUSTOMER_CREATE_ERROR]: state => {
        state.status = "error";
    },
    [CUSTOMER_UPDATE]: state => {
        state.status = "loading";
    },
    [CUSTOMER_UPDATE_SUCCESS]: state => {
        state.status = "success";
    },
    [CUSTOMER_UPDATE_ERROR]: state => {
        state.status = "error";
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.customer = {};
        state.allcustomers = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};